import dayjs from 'dayjs'
import React, { useEffect, useRef } from 'react'
import { Controller } from 'react-hook-form'
import Cleave from 'cleave.js/react'
import { Tooltip } from 'bootstrap'
import DOMPurify from 'dompurify'

export const TextField = ({
  id,
  label,
  control,
  name,
  rules,
  placeholder = '',
  type = 'text',
  error,
  info,
  cleaveOptions,
  ...props
}) => {
  const tooltipRef = useRef(null)

  useEffect(() => {
    if (info && tooltipRef.current) {
      const tooltip = new Tooltip(tooltipRef.current, {
        html: true,
      })
      return () => tooltip.dispose()
    }
  }, [info])

  return (
    <div className="b-field">
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <div
            className={`form-floating ${
              placeholder ? 'form-floating-with-placeholder' : ''
            }`}>
            {cleaveOptions ? (
              <Cleave
                {...field}
                id={id || name}
                options={cleaveOptions}
                className="form-control form-input-text"
                placeholder={placeholder}
                {...props}
              />
            ) : (
              <input
                {...field}
                id={id || name}
                type={type === 'date' ? 'text' : type}
                className="form-control form-input-text"
                placeholder={placeholder}
                {...props}
                value={
                  type === 'date' && field.value
                    ? dayjs(field.value).format('DD/MM/YYYY')
                    : field.value || ''
                }
                readOnly={
                  (type === 'date' && !props.disabled) || props.readOnly
                }
              />
            )}
            <label className="form-label" htmlFor={id || name}>
              {label}
            </label>
            {error && (
              <span className="field-validation-error error pb-0">
                {error.message}
              </span>
            )}
          </div>
        )}
      />
      {info && (
        <div
          ref={tooltipRef}
          className="b-field__info-icon"
          data-bs-toggle="tooltip"
          data-bs-title={DOMPurify.sanitize(info)}>
          <i className="icon icon-info"></i>
        </div>
      )}
    </div>
  )
}

export default TextField
